module.exports = __webpack_public_path__ + "image-f9edc1153b41.jpg";